"use strict";

spreadsheets.classy.controller({
    name: "SpreadsheetsSideNavController",
    inject: ["$scope", "$modal", "authServiceFactory", "$http", "ReportsModelService", "AccountModelService",
        "SpreadsheetsService", "SpreadsheetModelService", "AskSchoolSpecificQuestionsModelService"],
    init: function()
    {

        this.$.information = this.ReportsModelService.get();
    	this.$.reporttype = 0;
     	this.$.SpreadsheetsService = this.SpreadsheetsService;
        this.$.items = this.SpreadsheetsService.getItems();
        this.$.filter = { application: true, applicant: true};
       	this.$.ssq = this.AskSchoolSpecificQuestionsModelService.get();
        this.$.ssqtable();
        this.$.budgets = this.AccountModelService.get().accounts;
        this.$.budgettable();
        this.$.confidential = this.authServiceFactory.getAuth().permissions.confidential;
        this.$.origInformation = angular.copy(this.$.information);
        if (this.$.confidential==1) { //If we're in confidential mode, limit the fields you can create a spreadsheet with
            this.confidentialFilter();
        }
    },
    confidentialFilter: function() {
        this.$.information.applicant = this.$.information.applicant.slice(0, 13);
        this.$.information.combined = this.$.information.combined.slice(0, 8).concat(this.$.information.combined.slice(11, 17));
        this.$.information.family1 = this.$.information.family1.slice(0, 16).concat(this.$.information.family1.slice(101,102));
        this.$.information.family2 = this.$.information.family2.slice(0, 16).concat(this.$.information.family2.slice(101,102));

        //Remove spreadsheets that contain financial info
        //First, get arrays with ONLY financial fields
        var applicant2 = this.$.origInformation.applicant.slice(13, 15);
        var combined2 = this.$.origInformation.combined.slice(8, 11);
        var family12 = this.$.origInformation.family1.slice(16, 101);
        var family22 = this.$.origInformation.family2.slice(16, 101);

        //Then for every spreadsheet, loop through and loop through each array to look for bad values
        for (var i = 0; i < this.$.items.length; i++) {
            var flag = false; //if we find a match, skip the rest of the loops
            for (var p = 0; p < applicant2.length; p++) {
                if (this.$.items[i].spreadsheet.indexOf(applicant2[p].code)>=0) {
                    this.$.items.splice(i, 1);
                    flag = true;
                    break;
                }
            }
            if (flag==false) {
                for (var p = 0; p < combined2.length; p++) {
                    if (this.$.items[i].spreadsheet.indexOf(combined2[p].code)>=0) {
                        this.$.items.splice(i, 1);
                        flag = true;
                        break;
                    }
                }
            }
            if (flag==false) {
                for (var p = 0; p < family12.length; p++) {
                    if (this.$.items[i].spreadsheet.indexOf(family12[p].code)>=0) {
                        this.$.items.splice(i, 1);
                        flag = true;
                        break;
                    }
                }
            }
            if (flag==false) {
                for (var p = 0; p < family22.length; p++) {
                    if (this.$.items[i].spreadsheet.indexOf(family22[p].code)>=0) {
                        this.$.items.splice(i, 1);
                        flag = true;
                        break;
                    }
                }
            }
        }
    },
    ssqtable: function()
    {
        this.$.ssqlist = [];
        for (var i=1;i<3;i++) {
        	for (var j=0; j < this.$.ssq.length; j++) {
            	this.$.ssqlist.push({
                    recordID: this.$.ssq[j].recordID, 
                    Question: this.$.ssq[j].Question, 
                    familyID: i, title:"F"+i+"SchoolQuestion"+this.$.ssq[j].recordID, 
                    code:"SSQ"+this.$.ssq[j].recordID+"_F"+i
                });
        	}
      	}
   	},
    budgettable: function() {
        this.$.budgetlist = [];
        for (let j = 0; j < this.$.budgets.length; j++) {
            this.$.budgetlist.push({
                recordID: this.$.budgets[j].recordID,
                title: this.$.budgets[j].Account,
                code: "Budget_" + this.$.budgets[j].recordID
            });
        }
    },
    makelist: function(model)
    {
        var list = this.SpreadsheetsService.getList();
        if (list[list.length-1] != model && model != null) {
          list.push(model);
        }
        else {
          this.$.combined = "";
          this.$.family1 = "";
          this.$.family2 = "";
          this.$.awardData = "";
          this.$.schoolspecq = "";
          this.$.applicant = "";
        }
    },
    changeView: function(num)
    {
        if (num==0) {
            this.$.items = this.SpreadsheetsService.getItems();
            this.$.items.push(this.SpreadsheetsService.newItem());
        }
        this.$.SpreadsheetsService.resetSpreadsheet();
        this.$.SpreadsheetsService._type = num;
        this.$.reporttype = num;
    },
    changeNav: function(ss)
    {

        var parent = this;
        this.$.SpreadsheetsService._name = ss.name;
        this.$http.get("api/school/" + this.authServiceFactory.getAuth().schoolID + "/spreadsheetDB/" + ss.recordID).then(function(result) {
            parent.SpreadsheetsService.setList(result.data);
            if (ss.type === null)
                ss.type = 1;

            parent.SpreadsheetsService._type = ss.type;
            parent.SpreadsheetsService._id = ss.recordID;
            parent.$.reporttype = ss.type;
            parent.$.SpreadsheetsService.dirty = false;
        });

    },
    initDownloadModal: function(item)
    {
        return this.$modal.open({
            templateUrl: "fast/submodules/schoolside/reports/submodules/spreadsheets/partials/downloadReportsModal.html?v=" + versionNo,
            controller: "DownloadReportModalsController",
            resolve: {
                item: function()
                {
                    return {
                        id: item.recordID,
                        type: item.type
                    };
                }
            }
        });
    },
    delete: function(item)
    {
        var parent = this;
        swal({
            title: "Are you sure?",
            text: "Are you sure you want to delete spreadsheet '"+item.name+"'?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Delete",
            closeOnConfirm: true
        }, function()
        {
            item.deleted=1; 
            return parent.$http.delete("api/school/" + parent.authServiceFactory.getAuth().schoolID + "/spreadsheetDB/" + item.recordID)
            .success(function(data, status, headers, config) {
            });
        });

    }
});

